/* eslint-disable max-len */
import { decodeUrl, parseIntWithFallback } from 'sources/parsers/commons';

export const parse = item => ({
    id: item._id, // eslint-disable-line no-underscore-dangle
    linkProfileStrength: parseIntWithFallback(item?.lps),
    url: decodeUrl(item.url),
});
/* eslint-enable max-len */
